import { TypeRequest } from "../common/enums/AllEnums";
import { IResponse } from "../interfaces/IResponse";
import { IUserGroup } from "../interfaces/IUser";
import { BisAPI, BisApiRequest } from "./apis";

export const GetUserGroup = (): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Usuario/ObtenerGrupoUsuarios`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetUserGroupByUserID = (): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Usuario/ObtenerGrupoUsuariosByUsuario`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetUserGroupByID = (userGroupID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Usuario/ObtenerGrupoUsuarioByID?GrupoUsuarioID=${userGroupID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const DeactivateUserGroupByID = (userGroupID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Usuario/DesactivarGrupoUsuario?GrupoUsuarioID=${userGroupID}`, TypeRequest.put).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}
export const UpdateUserGroup = (userGroup: IUserGroup): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Usuario/ActualizarGrupoUsuario`, TypeRequest.put, userGroup).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const InsertUserGroup = (userGroup: IUserGroup): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Usuario/InsertarGrupoUsuario`, TypeRequest.post, userGroup).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}